import SurveysBuilder from './SurveysBuilder'
import SurveysBuilderEditor from './SurveysBuilderEditor'
import { Chrome } from 'vue-color'

Vue.component('chrome-picker', Chrome)
Vue.component('surveys-builder-editor', SurveysBuilderEditor)